export default {
    secure_checkout: 'Compra Segura',
    cart: 'Carrinho',
    photos: 'fotos',
    see_all: 'Ver todas',
    subscription: 'Assinatura',
    sold_out: 'Produto esgotado',
    subtotal: 'SubTotal',
    discount: 'Desconto',
    shipping: 'Frete',
    free: 'grátis',
    total: 'Total',
    recurring_info: '* Valor recorrente de acordo com o plano',
    description: 'Descrição',
    has_coupon: 'Tem um cupom de desconto? Clique aqui.',
    enter_coupon: 'Digite o Cupom de Desconto',
    apply: 'Aplicar',
    personal_data: 'Dados Pessoais',
    full_name: 'Nome Completo*',
    required_field: 'Este campo é obrigatório',
    review_form: 'Confira os campos destacados para concluir a compra.',
    email: 'Email*',
    phone: 'Celular (DDD + Whatsapp)*',
    document: 'CPF/CNPJ*',
    continue: 'Continuar',
    shipping_data: 'Dados de Entrega',
    zipcode: 'CEP*',
    street: 'Endereço* (rua, logradouro, etc)',
    number: 'Número*',
    complement: 'Complemento',
    neighborhood: 'Bairro*',
    city: 'Cidade*',
    state: 'Estado*',
    back: 'Voltar',
    payment_method: 'Forma de Pagamento',
    credit_card: 'Cartão de Crédito',
    billet: 'Boleto',
    pix: 'Pix',
    card_number: 'Número do Cartão*',
    card_name: 'Nome impresso no cartão*',
    expiry_month: 'Mês de Vencimento*',
    expiry_year: 'Ano de Vencimento*',
    security_code: 'Cód. de Segurança (CVV)*',
    security_code_short: 'Cód. de Segurança*',
    installments: 'Parcelas*',
    product_not_found: 'Produto não encontrado',
    product_not_found_msg: 'Infelizmente não encontramos o produto que você procurava.',
    buy_now: 'Comprar Agora',
    generate_billet: 'Gerar Boleto',
    pay: 'Pagar',
    pix_payment: 'Pagamento via Pix',
    billet_payment: 'Pagamento via Boleto',
    copy_code: 'Copiar código Pix',
    copied: 'Copiado!',
    billet_no_installments: 'Não é possível parcelar um boleto.',
    pay_until_due_date: 'Pague até a data de vencimento',
    billet_due_date_warning: 'Atente-se ao vencimento do boleto. Você pode pagar o boleto em qualquer banco ou casa lotérica até o dia do vencimento.',
    wait_payment_approval: 'Aguarde a aprovação do pagamento',
    billet_approval_time: 'Pagamentos com Boleto Bancário levam até 3 dias úteis para serem compensados e então terem os produtos liberados.',
    pix_payment_instructions: 'Basta usar o aplicativo do seu banco para realizar um pagamento via PIX. É fácil e rápido!',
    instant_payment: 'Pagamento Instantâneo',
    pix_approval_time: 'Pagamentos com Pix são processados instantaneamente, porem em alguns bancos pode demorar alguns minutos!',
    credit_card_fees: 'Taxa de parcelamento de 2,99% no cartão de crédito.',
    exclusive_offer_available: 'oferta exclusiva disponível',
    exclusive_offers_available: 'ofertas exclusivas disponíveis',
    for_you: 'para você:',
    get_offer: 'Pegar oferta',
    remove_offer: 'Remover oferta',
    offer_acquired: 'Oferta Adquirida',
    cart_has_sold_out_product: 'Seu carrinho tem produto esgotado, por favor remova-o para finalizar.',
    loading: 'Carregando',
    hoopay_processing: 'HooPay está processando este pagamento para o vendedor',
    type_discount_coupon: 'Digite um Cupom de Desconto',
    type_full_name: 'Digite o seu Nome Completo',
    type_email: 'Digite o seu Email',
    type_phone: 'Digite o seu Número de Celular',
    type_document: 'Digite o seu CPF ou CNPJ',
    type_zipcode: 'Digite o seu CEP',
    type_street: 'Digite o seu Endereço Completo',
    type_number: 'Digite o número do endereço',
    type_neighborhood: 'Digite o Bairro',
    type_city: 'Digite a Cidade',
    invalid_cpf: 'CPF inválido',
    invalid_cnpj: 'CNPJ inválido',
    invalid_email: 'Este email é inválido',
    generate_pix: 'Gerar PIX',
    finish_payment: 'Finalizar',
    order_observations: 'Observações sobre seu pedido',
    order_observations_placeholder: 'Detalhes do produto, nome do vendedor, instruções de entrega ou outras observações',
    recaptcha_protected: 'Este site é protegido pelo reCAPTCHA do Google',
    privacy_policy_terms: 'Política de privacidade e Termos de serviço',
    agree_terms: 'Ao continuar, você concorda com os Termos de Compra',
    choose_shipping: 'Escolha um frete',
    cannot_complete_purchase: 'No momento não é possível concluir essa compra',
    ok_got_it: 'Ok, entendi',
    countdown_finished: 'Seu tempo acabou, adquira seu acesso agora mesmo.',
    promotional_price_ending: 'Não perca essa oportunidade! Preço promocional acabará em breve..',
    privacy_policy: 'Política de privacidade',
    terms_of_service: 'Termos de serviço',
    installments_with_addition: '* Parcelamento com acréscimo',
    and: 'e',
    order_analyzing: 'Pedido em análise',
    transaction_safety_analysis: 'Sua transação está passando por uma análise de segurança.',
    safety_protocol_info: 'Fique tranquilo, isso faz parte dos nossos protocolos de segurança. Em breve o status do seu pedido será atualizado e você receberá uma notificação.',
    awaiting_payment: 'Aguardando pagamento',
    complete_purchase_payment: 'Realize o pagamento para concluir sua compra',
    pix_code: 'Código PIX',
    already_paid: 'Já fiz o pagamento',
    how_to_pay_pix: 'Como pagar com PIX',
    open_bank_app: 'Abra o app do seu banco',
    open_bank_app_desc: 'Acesse o aplicativo do seu banco ou instituição financeira',
    choose_pix_option: 'Escolha a opção PIX',
    choose_pix_option_desc: 'Selecione a opção PIX no menu principal do aplicativo',
    scan_qr_copy_code: 'Escaneie o QR Code ou cole o código',
    scan_qr_copy_code_desc: 'Utilize a câmera para ler o QR Code ou cole o código PIX copiado',
    confirm_payment_step: 'Confirme o pagamento',
    confirm_payment_step_desc: 'Verifique os dados e confirme a transação',
    pix_code_copied: 'Código PIX copiado com sucesso!',
    copy_error: 'Erro ao copiar o código',
    payment_not_identified: 'Pagamento não identificado',
    billet_instructions: 'Instruções',
    billet_after_expiration_warning: 'Após o vencimento, emitir um novo boleto.',
    billet_do_not_accept_after_expiration: 'Não aceitar pagamento após o vencimento.',
    billet_request_new_copy: 'Em caso de vencimento, pedir nova via.',
    billet_support_doubts: 'Dúvidas? Contate nosso suporte.',
    print_billet: 'Imprimir Boleto',
    payer_receipt: 'Recibo do Pagador',
    payment_location: 'Local de Pagamento',
    beneficiary_name_label: 'Nome do Beneficiário / CNPJ / CPF / Endereço:',
    doc_date: 'Data do documento',
    doc_number: 'Núm. do documento',
    doc_type: 'Espécie doc',
    acceptance: 'Aceite',
    processing_date: 'Data Processamento',
    our_number: 'Nosso Número',
    bank_use: 'Uso do Banco',
    wallet: 'Carteira',
    currency: 'Espécie',
    quantity: 'Quantidade',
    value: 'Valor',
    doc_value_label: '(=) Valor do Documento',
    discounts_label: '(-) Descontos/Abatimentos',
    interest_fine_label: '(+) Juros/Multa',
    paid_value_label: '(=) Valor Pago',
    payer_name: 'Nome do Pagador:',
    beneficiary_drawee: 'Sacador/Avalista:',
    address: 'Endereço',
    website: 'Site',
    expiry_date: 'Vencimento',
    agency_code_label: 'Agência / Código do Beneficiário',
    mechanical_authentication: 'Autenticação Mecânica',
    compensation_slip: 'Ficha de Compensação',
    amount_to_pay: 'Valor a pagar',
    due_date: 'Vencimento',
    billet_code: 'Linha Digitável',
    copy_code_tip: 'Copie o código acima para pagar no app do seu banco',
    download_view_pdf: 'Baixar/Visualizar PDF',
    payment_instructions: 'Instruções de Pagamento',
    billet_step_1_title: 'Copie o código ou baixe o PDF',
    billet_step_1_desc: 'Utilize a linha digitável ou imprima o boleto para pagar.',
    billet_step_2_title: 'Pague no seu banco',
    billet_step_2_desc: 'Use o aplicativo do seu banco ou vá até uma agência/lotérica.',
    billet_step_3_title: 'Aguarde a confirmação',
    billet_step_3_desc: 'O prazo de compensação é de até 3 dias úteis.',
    billet_code_copied: 'Código copiado com sucesso!',
    copy_error_billet: 'Erro ao copiar o código',
    security_validation: 'Validação de Segurança',
    security_validation_desc: 'Para sua proteção, confirme o documento cadastrado no pedido para visualizar os detalhes.',
    validating: 'Validando...',
    view_order: 'Visualizar Pedido',
    document_not_found: 'Documento não encontrado para este pedido',
    validation_error: 'Erro na validação. Verifique o documento.',
    your_content: 'Seu Conteúdo',
    acquired_materials_description: 'Abaixo estão todos os materiais que você adquiriu',
    search_content: 'Buscar conteúdo...',
    external_link: 'Link Externo',
    download: 'Baixar',
    open_link: 'Abrir Link',
    view: 'Visualizar',
    no_content_found: 'Nenhum conteúdo encontrado',
    try_changing_filters: 'Tente alterar os filtros ou termos de busca',
    browser_no_video_support: 'Seu navegador não suporta o elemento de vídeo.',
    all: 'Todos',
    images: 'Imagens',
    videos: 'Vídeos',
    documents: 'Documentos',
    links: 'Links',
    image_file: 'Arquivo de imagem',
    video_file: 'Arquivo de vídeo',
    download_document: 'Documento para download',
    download_file: 'Arquivo para download',
    file: 'Arquivo',
    product_not_found_msg_detailed: 'Não conseguimos localizar o produto. Por favor, entre em contato com o vendedor para mais informações.',
    order_refunded: 'Pedido Reembolsado',
    order_refunded_msg: 'O valor do seu pedido foi devolvido.',
    order_refunded_description: 'A transação de estorno foi concluída com sucesso. O valor será creditado na mesma conta ou fatura utilizada para o pagamento.',
    identifier: 'Identificador',
    loading_payment_info: 'Carregando informações do pagamento...',
    oops_something_wrong: 'Ops! Algo deu errado',
    order: 'Pedido',
    unrecognized_payment_type: 'Tipo de pagamento não reconhecido',
    uuid_not_provided: 'UUID do pedido não informado',
    order_not_found_check_uuid: 'Pedido não encontrado. Verifique se o UUID está correto.',
    error_loading_payment_try_again: 'Erro ao carregar dados do pagamento. Tente novamente mais tarde.',
    payment_successful: 'Pagamento efetuado!',
    order_info: 'Informações do Pedido',
    order_number: 'Número',
    loading_items: 'Carregando itens...',
    date: 'Data',
    customer_data: 'Dados do Cliente',
    cpf: 'CPF',
    phone_label: 'Telefone',
    shipping_address: 'Endereço de Entrega',
    support: 'Suporte',
    select_shipping_option: 'Selecione uma opção de frete',
    delivery: 'Entrega',
    days: 'dias',
    business_days: 'dias úteis',
    until: 'Até',
    today: 'hoje',
    order_delivery_forecast: 'Seu pedido será entregue',
    between: 'entre',
    invalid_zipcode: 'CEP inválido!',
    transaction_not_completed: 'Transação não concluída',
    payment_failed_gateway: 'O pagamento falhou no gateway. Verifique os dados ou tente outro método.',
    payment_status: 'Status do pagamento',
    // motivo da recusa do cartão (charges[].errorMessage.reason)
    sandbox: {
        banner: 'MODO TESTE (sandbox): nenhuma cobrança real é feita e nenhum pedido é gerado.',
        three_ds_prompt: '[SANDBOX] Simular autenticação 3DS do banco.\n\nOK = aprovar  |  Cancelar = recusar',
        simulate_payment: 'Simular pagamento (sandbox)',
        simulate_error: 'Não foi possível simular o pagamento.',
    },
    upsell: {
        title: 'Aproveite esta oferta',
        card: 'Pagamento no mesmo cartão final {lastDigits}',
        confirm: 'Confirmar compra',
        processing: 'Processando...',
        other_payment: 'Pagar de outra forma',
    },
    repurchase: {
        saved_cards: 'Seus cartões salvos',
        welcome: 'Que bom te ver de novo, {name}!',
        filled: 'Preenchemos seus dados da última compra.',
        confirm_document: 'Para sua segurança, confirme seu CPF/CNPJ ({document}).',
        not_you: 'Não é você? Usar outros dados',
        card: 'Cartão',
        expires: 'venc. {date}',
        other_card: 'Usar outro cartão',
        cvv_of: 'CVV do cartão final {lastDigits}',
        remember_me: 'Lembrar meus dados para as próximas compras',
    },
    card_verification: {
        title: 'Confirme o valor cobrado no seu cartão',
        step_open_app: 'Abra o app ou a fatura do seu banco',
        step_find_charge: 'Encontre a cobrança de verificação mais recente',
        step_type_amount: 'Digite o valor exato abaixo',
        description: 'Para sua segurança, fizemos uma cobrança de verificação entre R$ {min} e R$ {max} no seu cartão. Ela é estornada automaticamente.',
        amount_label: 'Valor cobrado no cartão final {lastDigits}',
        confirm: 'Confirmar valor e pagar',
        confirming: 'Confirmando...',
        cancel: 'Não encontrei a cobrança / usar outro cartão',
        expires_in: 'Tempo restante: {time}',
        attempts_left: 'Tentativas: {attempts}',
        wrong_amount: 'Valor incorreto. Confira no app do banco. Tentativas restantes: {attempts}',
        expired: 'O tempo para confirmar acabou. A cobrança de verificação será estornada.',
        canceled: 'Verificação cancelada e cobrança de verificação estornada. Você pode tentar com outro cartão.',
        cancel_pending: 'Verificação cancelada. A cobrança de verificação será estornada em alguns minutos.',
        error: 'Não foi possível confirmar o valor. Tente novamente.',
        refund_note: 'A cobrança de verificação é sempre estornada.',
    },
    three_d_secure: {
        hint: 'Confirme a compra com o banco do seu cartão.',
        waiting: 'Seguindo a confirmação do banco...',
        error: 'Não foi possível iniciar a confirmação com o banco. Tente novamente.',
    },
    captcha: {
        hint: 'Confirme a verificação de segurança para concluir o pagamento.',
        error: 'Não foi possível concluir a verificação de segurança. Tente novamente.',
    },
    billing_address: {
        title: 'Endereço de cobrança (opcional)',
        hint: 'Informar o endereço do titular do cartão aumenta as chances de aprovação.',
        zipcode: 'CEP',
        street: 'Endereço (rua, logradouro, etc)',
        number: 'Número',
        neighborhood: 'Bairro',
        city: 'Cidade',
        state: 'Estado (UF)',
    },
    charge_recovery: {
        pay_with_pix: 'Pagar com PIX',
        pay_with_pix_hint: 'Geramos o PIX na hora com os mesmos dados, sem precisar digitar nada.',
        fix_cc_securityCode: 'Corrigir o código de segurança',
        fix_cc_expiryMonth: 'Corrigir a validade',
        fix_cc_number: 'Corrigir o número do cartão',
        use_other_card: 'Digitar os dados do cartão',
    },
    charge_error: {
        insufficient_funds: {
            title: 'Saldo ou limite insuficiente',
            hint: 'Verifique o limite disponível no seu cartão ou tente com outro cartão.',
        },
        invalid_cvv: {
            title: 'Código de segurança inválido',
            hint: 'Confira o código de segurança (CVV) no verso do cartão e tente novamente.',
        },
        expired_card: {
            title: 'Cartão vencido',
            hint: 'Confira a data de validade ou utilize outro cartão.',
        },
        invalid_card_data: {
            title: 'Dados do cartão inválidos',
            hint: 'Confira o número, a validade e o nome do titular e tente novamente.',
        },
        card_blocked: {
            title: 'Cartão bloqueado ou com restrição',
            hint: 'Entre em contato com o banco emissor ou utilize outro cartão.',
        },
        transaction_not_allowed: {
            title: 'Compra não permitida para este cartão',
            hint: 'Seu cartão pode não estar habilitado para compras online. Fale com o banco ou utilize outro cartão.',
        },
        issuer_declined: {
            title: 'Pagamento recusado pelo banco',
            hint: 'O banco emissor não autorizou a compra. Entre em contato com ele ou utilize outro cartão.',
        },
        suspected_fraud: {
            title: 'Não foi possível validar a compra',
            hint: 'Por segurança, a compra não foi aprovada. Tente com outro cartão ou outra forma de pagamento.',
        },
        attempts_exceeded: {
            title: 'Limite de tentativas excedido',
            hint: 'Aguarde alguns minutos e tente novamente, ou utilize outro cartão.',
        },
        invalid_amount: {
            title: 'Valor não permitido no cartão',
            hint: 'Tente outra forma de pagamento.',
        },
        try_again: {
            title: 'Instabilidade no processamento',
            hint: 'Não foi possível concluir agora. Aguarde alguns instantes e tente novamente.',
        },
        authentication_failed: {
            title: 'Compra não autenticada pelo banco',
            hint: 'O banco emissor não confirmou a compra. Tente novamente concluindo a confirmação do banco, ou use outro cartão ou forma de pagamento.',
        },
        generic: {
            title: 'Pagamento não autorizado',
            hint: 'Confira os dados do cartão ou tente com outro cartão ou forma de pagamento.',
        },
        payment_unavailable: {
            title: 'Não foi possível gerar o pagamento',
            hint: 'Tente novamente em alguns instantes ou escolha outra forma de pagamento.',
        },
    },
    weekly: 'semanal',
    biweekly: 'quinzenal',
    monthly: 'mensal',
    quarterly: 'trimestral',
    semiannual: 'semestral',
    yearly: 'anual',
    product_added_to_cart: 'Produto adicionado ao carrinho',
    error_processing_payment: 'Erro ao processar pagamento',
    offer_removed: 'Oferta removida',
    automatic_discount_applied: 'Desconto Automático!',
    coupon_applied: 'Cupom Aplicado!',
    invalid_coupon: 'Cupom inválido',
    expired_coupon: 'Cupom expirado',
    coupon_not_applicable: 'Cupom não aplicável para este produto',
    convert_to: 'Converter em:',
    currency_brl: 'Real brasileiro (R$)',
    currency_usd: 'Dólar americano ($)',
    currency_eur: 'Euro (€)',
}
